import { AbstractModel } from '.';

export class NotificationSettingsModel extends AbstractModel {
    endpoint = 'notification-settings';
}
